import {
  ICS204_OSC_REVIEW_ROLE,
  ICS204_PREPARED_BY_SIGN_ROLE,
  ICS204_PSC_REVIEW_ROLE,
  type SignatureCompletionStatus,
  type SignatureSlot,
  type WalaSignature,
  formatSignatureCompletionStatus,
  formatSignatureDateTime,
  formatSignatureDraftLabel,
  getSignatureCompletion,
  isVersionFullySigned,
  isVersionLockedBySignatures,
  parseWalaSignatures,
} from './ics204SignatureSlots';

export type Ics204aSignature = WalaSignature;

export {
  ICS204_OSC_REVIEW_ROLE,
  ICS204_PREPARED_BY_SIGN_ROLE,
  ICS204_PSC_REVIEW_ROLE,
  formatSignatureCompletionStatus,
  formatSignatureDateTime,
  formatSignatureDraftLabel,
  getSignatureCompletion,
  isVersionFullySigned,
  isVersionLockedBySignatures,
  parseWalaSignatures,
};
export type { SignatureCompletionStatus, SignatureSlot };

/** ICS-204A Boxes 12–14 signature slots (same role rules as ICS-204 Boxes 9–11). */
export const ICS204A_REQUIRED_SIGNATURE_SLOTS: SignatureSlot[] = [
  {
    id: 'prepared-by',
    label: 'Prepared By',
    boxLabel: '12. Prepared by',
    role: ICS204_PREPARED_BY_SIGN_ROLE,
    isComplete: (signatures) => signatures.length > 0 && signatures[0] != null,
    findSignature: (signatures) => signatures[0],
  },
  {
    id: 'review-psc',
    label: ICS204_PSC_REVIEW_ROLE,
    boxLabel: '13. Reviewed by (PSC)',
    role: ICS204_PSC_REVIEW_ROLE,
    isComplete: (signatures) =>
      signatures.some(
        (signature, index) =>
          index > 0 && signature.role === ICS204_PSC_REVIEW_ROLE
      ),
    findSignature: (signatures) =>
      signatures.find(
        (signature, index) =>
          index > 0 && signature.role === ICS204_PSC_REVIEW_ROLE
      ),
  },
  {
    id: 'review-osc',
    label: ICS204_OSC_REVIEW_ROLE,
    boxLabel: '14. Reviewed by (OSC/ISC)',
    role: ICS204_OSC_REVIEW_ROLE,
    isComplete: (signatures) =>
      signatures.some(
        (signature, index) =>
          index > 0 && signature.role === ICS204_OSC_REVIEW_ROLE
      ),
    findSignature: (signatures) =>
      signatures.find(
        (signature, index) =>
          index > 0 && signature.role === ICS204_OSC_REVIEW_ROLE
      ),
  },
];
